import { MutationTree } from "vuex";
import ProcessTemplate from "@/types/documents/process/ProcessTemplate";
import { IDataProvider } from "@/store";
import { IProcessTemplateState } from "@/store/modules/processTemplate/state";

export enum ProcessTemplateMutations {
  SET_ONE = "SET_ONE_PROCESS_TEMPLATE",
  SET_ALL = "SET_ALL_PROCESS_TEMPLATE",
  SET_LAZY_DATA = "SET_LAZY_DATA_PROCESS_TEMPLATE",
}

export const mutations: MutationTree<IProcessTemplateState> = {
  [ProcessTemplateMutations.SET_ONE](state, payload: ProcessTemplate) {
    state.processTemplate = payload;
  },
  [ProcessTemplateMutations.SET_ALL](state, payload: ProcessTemplate[]) {
    state.processTemplates = payload;
  },
  [ProcessTemplateMutations.SET_LAZY_DATA](
    state,
    payload: IDataProvider<ProcessTemplate>
  ) {
    state.dataProvider = payload;
  },
};
